import type { UserPreferencesNotificationsProps } from "./user-preferences-notifications.type";

import { useTranslation } from "react-i18next";

import { groupNotificationsByType } from "@/entities/referential/referential-notifications";
import { CardInView } from "@/ui/card-in-view";

import { UserPreferencesNotificationsFooter } from "./user-preferences-notifications-footer";
import { UserPreferencesNotificationsHeader } from "./user-preferences-notifications-header";
import { UserPreferencesNotificationsTable } from "./user-preferences-notifications-table";
import { UserPreferencesNotificationsProvider } from "./user-preferences-notifications.provider";

export const UserPreferencesNotifications = ({
  notifications,
  savedSettings,
}: UserPreferencesNotificationsProps) => {
  const { t } = useTranslation();

  const notificationsByType = groupNotificationsByType(notifications);

  return (
    <UserPreferencesNotificationsProvider
      notifications={notifications}
      savedSettings={savedSettings}
    >
      <CardInView
        title={t("user:preferences.notifications.title")}
        headerActions={
          <UserPreferencesNotificationsHeader notifications={notifications} />
        }
        footerActions={<UserPreferencesNotificationsFooter />}
      >
        {Object.entries(notificationsByType).map(([type, notifications]) => (
          <UserPreferencesNotificationsTable
            key={type}
            title={t(`user:preferences.notifications.groupsTitle.${type}`)}
            notifications={notifications}
          />
        ))}
      </CardInView>
    </UserPreferencesNotificationsProvider>
  );
};
